var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLikeIcon = function SvgLikeIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#A1A1AA",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.64,
    d: "M19.575 5.328a4.86 4.86 0 0 0-6.883 0L12 6.03l-.693-.702a4.86 4.86 0 0 0-6.882 0c-1.908 1.908-2.025 5.128.378 7.575L12 20.101l7.197-7.198c2.402-2.447 2.285-5.667.378-7.575"
  })));
};
export default SvgLikeIcon;